import React from "react";
import DesktopTransactionApprovalItem from "./DesktopTransactionApprovalItem";
import { getCategoryIcon } from "../../utils/categoryIcons";
import { formatAmount } from "./transactionGroupingUtils";

export default function TransactionGroup({
    groupKey,
    title,
    transactions,
    totalAmount,
    isCollapsed,
    onToggleCollapse,
    isSpecial = false,
    categoryLookup,
    tagLookup,
    approvalMode,
    removeTransactionCallback,
    showSaveError,
    showSaveSuccess,
    showDeleteError,
    showDeleteSuccess,
    selectedTransactions,
    onSelectionChange,
    selectionMode
}) {
    return (
        <div style={{
            marginBottom: "2px"
        }}>
            <div
                onClick={() => onToggleCollapse(groupKey)}
                style={{
                    backgroundColor: isSpecial ? "#FFF9E6" : "#F8F9FA",
                    padding: "10px 20px",
                    cursor: "pointer",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    direction: "rtl",
                    borderBottom: "1px solid #E0E0E0",
                    transition: "background-color 0.2s"
                }}
                onMouseEnter={(e) => e.currentTarget.style.backgroundColor = isSpecial ? "#FFF3CD" : "#EEEEEE"}
                onMouseLeave={(e) => e.currentTarget.style.backgroundColor = isSpecial ? "#FFF9E6" : "#F8F9FA"}
            >
                <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                    <span style={{ fontSize: "14px", color: "#666" }}>
                        {isCollapsed ? '◀' : '▼'}
                    </span>
                    {!isSpecial && (
                        <span style={{ fontSize: "16px" }}>
                            {getCategoryIcon(title)}
                        </span>
                    )}
                    <span style={{ fontSize: "14px", fontWeight: "600", color: "#333" }}>
                        {title}
                    </span>
                    <span style={{
                        fontSize: "12px",
                        color: "#999",
                        backgroundColor: "white",
                        padding: "2px 8px",
                        borderRadius: "10px",
                        border: "1px solid #E0E0E0"
                    }}>
                        {transactions.length}
                    </span>
                    {totalAmount !== undefined && (
                        <span style={{
                            fontSize: "13px",
                            fontWeight: "600",
                            color: "#2196F3",
                            backgroundColor: "#E3F2FD",
                            padding: "3px 10px",
                            borderRadius: "10px",
                            border: "1px solid #90CAF9"
                        }}>
                            ₪{formatAmount(totalAmount)}
                        </span>
                    )}
                </div>
                {isSpecial && (
                    <span style={{
                        color: "#F57C00",
                        fontSize: "11px",
                        fontWeight: "500"
                    }}>
                        ⚠️ דורש בירור
                    </span>
                )}
            </div>
            {!isCollapsed && (
                <div>
                    {transactions.map((item) => (
                        <div key={item.id}>
                            <DesktopTransactionApprovalItem
                                item={item}
                                categoryLookup={categoryLookup}
                                tagLookup={tagLookup}
                                approvalMode={approvalMode}
                                removeTransactionCallback={removeTransactionCallback}
                                showSaveError={showSaveError}
                                showSaveSuccess={showSaveSuccess}
                                showDeleteError={showDeleteError}
                                showDeleteSuccess={showDeleteSuccess}
                                isSelected={selectedTransactions.has(item.id)}
                                onSelectionChange={onSelectionChange}
                                selectionMode={selectionMode}
                            />
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}